module.exports = __webpack_public_path__ + "img/1586991378.d006f68c.jpg";